import React from 'react'
import Modal from '../../Layout/Modal'

const ModalFormVideo = ({ modalId2, onCloseModal2, Common, videoUrl, onFormVideoChange, onSaveVideo, languages, videoDescs, videoLang }) => {
    return (
        <Modal id={modalId2} title="Form Video" onClose={onCloseModal2} onAction={onSaveVideo} btnActionName="Save Video" modalSize="modal-lg">
            <div className='col-md-12'>
                <div className='form-group'>
                    <label>Video URL</label>
                    <div className='d-flex'>
                        <input className='form-control mr-2' style={{ width: "60%" }} value={Common.ytEmbedUrlView} readOnly={true} />
                        <input name='videoUrl' className='form-control' style={{ width: "40%" }} value={videoUrl} onChange={onFormVideoChange} placeholder="Paste Your Video ID Here!" />
                    </div>
                </div>

                <div className='form-group'>
                    <label>Language</label>
                    <div className='d-flex justify-content-between'>
                        <select name='videoLang' className='form-control mr-2' value={videoLang} onChange={onFormVideoChange}>
                            <option value={''}>Select Language</option>
                            {
                                languages.length > 0 && languages.map((item, i) => {
                                    if (videoDescs.findIndex(vd => vd.language_code == item.language_code) < 0) {
                                        return <option key={'lang-' + i} value={item.language_code}>{item.language_name}</option>
                                    }
                                })
                            }
                        </select>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default ModalFormVideo